import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { DamageC1Code, emptyC1Code } from "../../../services/damage/DamageC1Code";
import FormField from "../../../components/form-field/FormField";
import { RequiredOptionValidatorModel } from "../../../services/form/validators/required/RequiredOptionValidator";
import { Dropdown } from "../../../components/dropdown/Dropdown";

interface EditC1CodeProps {
  labelKey: string;
  value?: DamageC1Code;
  c1Codes: DamageC1Code[];
  onChange: (c1Code: DamageC1Code) => void;
  disabled: boolean;
  setFieldValue: Function;
}

export default observer(function EditC1Code(props: EditC1CodeProps) {
  const { labelKey, value, c1Codes, onChange, disabled, setFieldValue } = props;
  const [requiredOptionValidator] = useState(() =>
    RequiredOptionValidatorModel.create({ option: value })
  );

  useEffect(() => {
    requiredOptionValidator.set(value);
  }, [requiredOptionValidator, value]);

  return (
    <FormField
      id="c1-code"
      labelKey={labelKey || "general.damage.characterization1"}
      fieldName="c1Code"
      fieldValue={value}
      validator={requiredOptionValidator}
      required
      disabled={disabled}
      children={() => (
        <div className="form-element-container">
          <Dropdown
            selectedOption={
              value && value.code !== emptyC1Code.code
                ? { ...value, id: value.code, name: value.label }
                : null
            }
            options={c1Codes.map((x) => ({ ...x, id: x.code, name: x.label }))}
            onChange={onChange}
            fieldName="c1Code"
            setFieldValue={setFieldValue}
            disabled={disabled}
            placeholderKey="EditDamage.c1Code.selection"
          />
        </div>
      )}
      errorName="c1Code"
    />
  );
});
